import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { DocScope, DocService, DocsService } from '../doc';
import { FolderMutationOutboxService } from '../folder-api';
import { AccessibleFolderCacheStore } from '../organize';
import { TemplateDocService } from '../template-doc';
import { WorkspaceScope } from '../workspace';
import { WorkspaceService } from '../workspace';
import { JournalService } from './services/journal';
import { JournalDocService } from './services/journal-doc';
import { JournalStore } from './store/journal';

export const JOURNAL_SIDEBAR_TAB_ID = 'journal';

export {
  JOURNAL_DATE_FORMAT,
  JOURNAL_FOLDER_NAME,
  journalFolderId,
  JournalService,
  type MaybeDate,
} from './services/journal';
export { JournalDocService } from './services/journal-doc';
export { suggestJournalDate } from './suggest-journal-date';

export function configureJournalModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(JournalService, [
      JournalStore,
      DocsService,
      TemplateDocService,
      WorkspaceService,
      WorkspaceServerService,
      AccessibleFolderCacheStore,
      FolderMutationOutboxService,
    ])
    .store(JournalStore, [DocsService])
    .scope(DocScope)
    .service(JournalDocService, [DocService, JournalService]);
}
